import request from '../../../core/wrappers/axios-wrapper';
import { RoleApprovalCommand } from '../../../types/constants/apiUrls/roleApproval/roleApprovalCommand';
import { RequestType } from '../../../types/enums/request-enums';

const CreateRoleApprover = (params: any): Promise<any> =>
    request({
        url: RoleApprovalCommand.CreateRoleApprover,
        method: RequestType.POST,
        data: params,
    });

const UpdateRoleApprover = (params: any): Promise<any> =>
    request({
        url: RoleApprovalCommand.UpdateRoleApprover,
        method: RequestType.PUT,
        data: params,
    });

const DeleteRoleApprover = (params: any): Promise<any> =>
    request({
        url: RoleApprovalCommand.DeleteRoleApprover,
        method: RequestType.DELETE,
        data: params,
    });

const CreateUserRoleApprovalRequest = (params: any): Promise<any> =>
    request({
        url: RoleApprovalCommand.CreateUserRoleApprovalRequest,
        method: RequestType.POST,
        data: params,
    });

const ApproveRejectUserRoleRequest = (params: any): Promise<any> =>
    request({
        url: RoleApprovalCommand.ApproveRejectUserRoleRequest,
        method: RequestType.PUT,
        data: params,
    });

const BulkApproveRejectUserRoleRequest = (params: any): Promise<any> =>
    request({
        url: RoleApprovalCommand.BulkApproveRejectUserRoleRequest,
        method: RequestType.PUT,
        data: params,
    });

const UpdateRoleRequestability = (params: any): Promise<any> =>
    request({
        url: RoleApprovalCommand.UpdateRoleRequestability,
        method: RequestType.PUT,
        data: params,
    });

const RoleApprovalCommandService = {
    CreateRoleApprover,
    UpdateRoleApprover,
    DeleteRoleApprover,
    CreateUserRoleApprovalRequest,
    ApproveRejectUserRoleRequest,
    BulkApproveRejectUserRoleRequest,
    UpdateRoleRequestability,
};

export default RoleApprovalCommandService;
